import React from 'react';

function TechnologyCard({ name, description, logo, children }) {
  return (
    <div className="technology-card">
      <div className="tech-icon">
        {logo || children}
      </div>
      <h3>{name}</h3>
      <p>{description}</p>
    </div>
  );
}

export default TechnologyCard;
